export const SETTIGNS = 'Settings';
export const OPP_LIST_VIEW = 'Opportunity List view';
export const ACTION_PANEL = 'Action Panel';
export const OPENING_ACTION = 'Opening Action';
export const INVENTORY = 'Inventory';
export const TABS = 'Tabs';
export const OPENING_OPPORTUNITY = 'Open Opportunity';
export const SEARCH_OPPORTUNITY = 'Search Opportunity';
export const BANNER = 'Click Banner';
